import i18n from "@/lib/i18n";
import type { TemplateKey } from "@/types";

interface TemplateConfig {
  key: TemplateKey;
  label: string;
  description: string;
}

export function getSummaryTemplates(): TemplateConfig[] {
  return [
    {
      key: "default",
      label: i18n.t("templates.default"),
      description: i18n.t("templates.defaultDesc"),
    },
    {
      key: "avocat",
      label: i18n.t("templates.avocat"),
      description: i18n.t("templates.avocatDesc"),
    },
    {
      key: "consultant",
      label: i18n.t("templates.consultant"),
      description: i18n.t("templates.consultantDesc"),
    },
    {
      key: "association",
      label: i18n.t("templates.association"),
      description: i18n.t("templates.associationDesc"),
    },
    {
      key: "commercial",
      label: i18n.t("templates.commercial"),
      description: i18n.t("templates.commercialDesc"),
    },
  ];
}
